import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import config from "../../config.json";
import { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PhoneIcon from '@mui/icons-material/Phone';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import ForestIcon from '@mui/icons-material/Forest';
import NatureIcon from '@mui/icons-material/Nature';
import OpacityIcon from '@mui/icons-material/Opacity';
import { createTheme, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import LeftSubDrawerMobile from './LeftSubDrawerMobile.component';
import LeftSubDrawerDesktop from './LeftSubDrawerDesktop.component';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import SvgIcon from '@mui/material/SvgIcon';
import {Link,Typography } from '@mui/material';
import FAQ_Waldzustand from '../../Ressources/FAQs_Waldzustand_062022.pdf';
import FAQ_Baumarten from "../../Ressources/FAQs_Baumarten_062022.pdf";
import {
    EmailShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from "react-share";
import {
    EmailIcon,
    LinkedinIcon,
    TwitterIcon,
    WhatsappIcon,
} from "react-share";




function MixedForestIcon(props: any) {
    return (
        <SvgIcon {...props}>
            <path d="M22.3,18.25h-5.28v3.75h-2.98v-3.75h-1.9c2.38-1.35,3.96-3.9,3.96-6.79,0-2.08-.82-3.97-2.16-5.37l1.58-2.83,5.27,9.37h-1.5l3.01,5.62Zm-13.19,3.75v-3.78c3.38-.4,6-3.27,6-6.76,0-3.77-3.05-6.81-6.81-6.81S1.49,7.7,1.49,11.46c0,3.38,2.45,6.17,5.67,6.7v3.83h1.95Z"
            />
        </SvgIcon>
    );
}

export default function LeftSubDrawer(props: any) {
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));
    let content = (<></>)
    let title = "";


    const handleChangeWaldzustandsLayer = (event: React.SyntheticEvent, newValue: number) => {
        props.setTabIndexWaldzustand(newValue);
        console.log("new value", newValue)

        switch (newValue) {
            case 0:
                props.setActiveLayer("waldbiomasseTrend")
                break;
            case 1:
                props.setActiveLayer("laubwaldTrend")
                break;
            case 2:
                props.setActiveLayer("nadelwaldTrend")
                break;
            case 3:
                props.setActiveLayer("laubwaldWasserTrend")
                break;
        }

    };


    switch (props.leftSubDrawerType) {
        case "FIRE":
    const links = {
        firmsFaq: "https://www.earthdata.nasa.gov/faq/firms-faq#ed-fire-on-ground",
        firmsDisclaimer: "https://www.earthdata.nasa.gov/learn/find-data/near-real-time/citation",
        dwd: "https://www.dwd.de/DE/leistungen/waldbrandgef/waldbrandgef.html"

    }

            content =
                (
                    <Box m={2}>
                        <Typography>
Diese Daten zeigen die Nah-Echtzeit Detektionen aktiver Feuer der Satelliten MODIS
                            (Moderate Resolution Imaging Spectroradiometer) und VIIRS (Visible Infrared Imaging Radiometer Suite)
                            der letzten sieben Tage. Die Daten werden mehrmals täglich aktualisiert.
                            Es werden nur die Feuerdetektionen dargestellt, die in Wäldern oder in direkter Nähe zu Wäldern auftreten,
                            bzw. aufgetreten sind.
                            Bei Industrieanlagen (mit starken Hitzequellen) in direkter Nachbarschaft zu Wäldern kann es zu fehlerhaften
                            Feuerdetektionen kommen. Aufgrund der räumlichen Auflösung von VIIRS mit ca. 375 m sowie von MODIS mit ca. 1000 m,
                            können die Detektionen einen entsprechenden räumlichen Versatz zu den tatsächlichen Feuern aufweisen.
                        </Typography>
                        <Typography gutterBottom>
                            Die Daten stammen vom NASA Fire Information for Resource Management System (FIRMS) und werden für den Waldmonitor Deutschland
                            aufbereitet und gefiltert dargestellt. Verwenden Sie diese Informationen nicht unmittelbar für den Erhalt des Lebens oder Ihres Eigentums.
                            Die von den Satelliten abgeleiteten aktiven Feuer-/Temperaturanomalien haben eine begrenzte Genauigkeit,
                            welche <Link href={links.firmsFaq} target="_blank">hier</Link> näher beschrieben sind.
                            Bitte beachten Sie auch den <Link href={links.firmsDisclaimer} target="_blank">Haftungsausschluss</Link> von FIRMS.
                        </Typography>
                        <Typography>
                            Der Deutsche Wetterdienst bietet zudem fortlaufend Informationen über die <Link href={links.dwd} target="_blank">aktuelle Waldbrandgefahr</Link>.


                        </Typography>
                    </Box>

                );
            title = "Aktive Feuer (7 Tage)";
            break;

        case "BAUMARTEN":
            content =
                (
                    <Box m={2}>
                        <h3>Kartierung der 7 Hauptbaumarten (2017)</h3>
                        <Typography variant="body1" gutterBottom>
                            {config["layersBaumarten"][0].description}
                        </Typography>
                    </Box>

                );
            title = "Baumarten (2017)";
            break;


        case "WALDZUSTAND":
            content =
                (
                    < Box >
                        {props.mobile ?
                            <Tabs variant="scrollable" allowScrollButtonsMobile value={props.tabIndexWaldzustand} onChange={handleChangeWaldzustandsLayer} aria-label="icon tabs example">
                                <Tab icon={<MixedForestIcon />} aria-label="phone" />
                                <Tab icon={<NatureIcon />} aria-label="phone" />
                                <Tab icon={<ForestIcon />} aria-label="favorite" />
                                <Tab icon={<OpacityIcon />} aria-label="person" />
                            </Tabs> :
                            <Tabs variant="fullWidth" value={props.tabIndexWaldzustand} onChange={handleChangeWaldzustandsLayer} aria-label="icon tabs example">
                                <Tab icon={<MixedForestIcon />} aria-label="phone" />
                                <Tab icon={<NatureIcon />} aria-label="phone" />
                                <Tab icon={<ForestIcon />} aria-label="favorite" />
                                <Tab icon={<OpacityIcon />} aria-label="person" />
                            </Tabs>



                        }

                        <Box m={2}>
                            <h4>{config["layersWaldzustand"][props.tabIndexWaldzustand].name}</h4>
                            <Typography variant="body1" gutterBottom>
                                {config["layersWaldzustand"][props.tabIndexWaldzustand].description}
                            </Typography>
                        </Box>
                    </Box >

                );
            title = "Waldzustand";
            break;
        case "SCHADEN":
            content =
                (
                    <Box m={2}>
                        <h3>Schadflächen 2017-2023</h3>
                        <Typography variant="body1" gutterBottom>
                            {config["layersSchaden"][0].description}
                        </Typography>
                    </Box>

                );
            title = "Schadflächen";
            break;
        case "BUNDESLAENDER":
            content =
                (
                    <BasicSelect
                        bundesland={props.bundesland}
                        setBundesland={props.setBundesland}
                    />

                );
            title = "Bundesland auswählen";

            break;

        case "INFORMATIONEN":
            content =
                (
                    <Box m={2}>
                        <Typography variant="body1" gutterBottom>

                            <p>Mehr Informationen finden Sie in den FAQs </p>
                            FAQ Waldzustand: <a href={FAQ_Waldzustand} rel="noopener noreferrer" target="_blank">
                                <u className='link_underlined'>hier</u> </a><br />
                            FAQ Baumarten: <a href={FAQ_Baumarten} rel="noopener noreferrer" target="_blank">
                                <u className='link_underlined'>hier</u> </a><br />
                            <Typography variant="body1" gutterBottom marginTop={6}>
                                Publikation: <a href="https://www.mdpi.com/2072-4292/14/14/3330/pdf" target="_blank">
                                    <u className='link_underlined'>hier</u> </a>
                            </Typography>
                            <Typography variant="body1" gutterBottom marginTop={6}>
                                <div>Wir freuen uns auf Ihr Feedback: </div>
                                <a className='link_underlined' href="mailto:support@remote-sensing-solutions.com?body=Request Waldmonitor">support@remote-sensing-solutions.com</a>
                            </Typography>
                        </Typography>
                    </Box>
                );
            title = "Informationen";
            break;

        case "TEILEN":
            const iconSize = 40
            content =
                (
                    <Box m={2}>
                        <Grid container justifyContent="space-evenly">
                            <Grid item>
                                <TwitterShareButton
                                    url={"https://map3d.remote-sensing-solutions.de/waldmonitor-deutschland/"}
                                    title="Release des Waldmonitors Deutschland"
                                    hashtags={["Waldmonitor", "Klimaschutz", "Klimawandel", "Naturgefahren", "Wald", "RemoteSensingSolutions", "NaturwaldAkademie"]}
                                // description={"aiueo"}
                                >
                                    <TwitterIcon size={iconSize} round />
                                </TwitterShareButton>
                            </Grid>
                            <Grid item>

                                <LinkedinShareButton
                                    url={"https://map3d.remote-sensing-solutions.de/waldmonitor-deutschland/"}
                                    title="Release des Waldmonitors Deutschland"
                                    summary='Der Waldmonitor Deutschland liefert erstmals eine satellitenbasierte Darstellung des Waldzustandes und der Verteilung der Hauptbaumarten.'
                                >
                                    <LinkedinIcon size={iconSize} round />
                                </LinkedinShareButton>
                            </Grid>
                            <Grid item>

                                <EmailShareButton
                                    url={"https://map3d.remote-sensing-solutions.de/waldmonitor-deutschland/"}
                                    subject="Release des Waldmonitors Deutschland"
                                    body='Der Waldmonitor Deutschland liefert erstmals eine satellitenbasierte Darstellung des Waldzustandes und der Verteilung der Hauptbaumarten.'

                                // description={"aiueo"}
                                >
                                    <EmailIcon size={iconSize} round />
                                </EmailShareButton>
                            </Grid>

                            <Grid item>

                                <WhatsappShareButton
                                    url={"https://map3d.remote-sensing-solutions.de/waldmonitor-deutschland/"}
                                    title="Release des Waldmonitors Deutschland"

                                // description={"aiueo"}
                                >
                                    <WhatsappIcon size={iconSize} round />
                                </WhatsappShareButton>
                            </Grid>

                        </Grid>
                    </Box>
                );
            title = "Teilen";

            break;


    }


    return (<>

        {mobile ?
            <LeftSubDrawerMobile
                title={title}
                {...props}

            >
                {content}
            </LeftSubDrawerMobile>

            :
            <LeftSubDrawerDesktop
                title={title}
                {...props}
            >
                {content}
            </LeftSubDrawerDesktop>
        }
    </>
    );
}


function BasicSelect(props: any) {

    const handleChange = (event: SelectChangeEvent) => {
        props.setBundesland(event.target.value as string);
    };

    return (
        <Box sx={{ m: 3 }}>
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Bundesland</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={props.bundesland}
                    label="Bundesland"
                    onChange={handleChange}
                >
                    {config["bundeslaenderList"].map((item) =>
                        <MenuItem key={item.label} aria-label={item.label} value={item.label}>{item.name}</MenuItem>
                    )
                    }
                </Select>
            </FormControl>
        </Box>
    );
}